<div aria-labelledby="dropdownConfig">
  <div>
    <h4 [qcId]="'filter-window'" class="filter-title text-black">التصفية</h4>
    <form [formGroup]="form_Group" (ngSubmit)="onFilter()">
      <div class="row align-items-baseline">
        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{"CreateOrUpdateUser.UserType" | translate}}
            </label>
            <ng-select [qcId]="'user-type'" width="100%" [items]="userTypes" bindValue="id" bindLabel="name"
              formControlName="userType" [multiple]="false" [placeholder]="'Global.Choose' | translate">
            </ng-select>
          </div>
        </div>

        <div class="col-sm-6 col-12">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{"CreateOrUpdateUser.ActiveStatusFilter" | translate}}
            </label>
            <ng-select [qcId]="'user-status'" width="100%" [items]="userStatus" bindValue="id" bindLabel="name"
              formControlName="userStatus" [multiple]="false" [placeholder]="'Global.Choose' | translate">
            </ng-select>
          </div>
        </div>

        <div class="col-sm-12 col-12">
          <div class="form-group">
            <label for="text" class="mb-3">
              {{"CreateOrUpdateUser.Permissions" | translate}}

            </label>
            <ng-select [qcId]="'user-permissions'" width="100%" [items]="displayedPermissions" bindValue="id"
              bindLabel="name" formControlName="permissions" [multiple]="true"
              [placeholder]="'Global.Choose' | translate" (change)="selectPermission($event)">
            </ng-select>
          </div>
        </div>
      </div>
      <div class="dropdown-footer d-flex justify-content-end">
        <button [qcId]="'reset-btn'" class="btn btn-outline-default" (click)="resetForm()">
          <i class="fa-solid fa-rotate-right"></i>
          <span> اعادة تعيين </span>
        </button>
        <button [qcId]="'submit-btn'" class="btn btn-green">
          تطبيق التصفية
        </button>
      </div>
    </form>
  </div>
</div>